import {ComputationReferenceInterface} from "../../app/shared/interfaces/computation/computation-reference.interface";

export const computations: ComputationReferenceInterface[] = [
  {
    id: 'priority',
    name: 'Default',
    description: "Select as many inputs as needed. If the first one exist, it will be the result. If it doesn't, we'll check the next one and so on.",
    type: 'standard',
    outputType: ['any'],
    inputs: true,
    onlyOneInput: true,
    group: 'basic',
    hasExample: true
  },
  {
    id: 'max',
    name: 'Maximum',
    description: 'Get the maximum value from the input list.',
    type: 'standard',
    outputType: ['number'],
    inputs: true,
    onlyOneInput: false,
    group: 'basic',
    hasExample: true
  },
  {
    id: 'min',
    name: 'Minimum',
    description: 'Get the minimum value from the input list.',
    type: 'standard',
    outputType: ['number'],
    inputs: true,
    onlyOneInput: false,
    group: 'basic',
    hasExample: true
  },
  {
    id: 'comparison',
    name: 'Comparison',
    description: "Compare an input with a value. It will return a boolean with the comparison result.",
    type: 'standard',
    outputType: ['boolean'],
    inputs: false,
    onlyOneInput: true,
    group: 'basic'
  },
  // {
  //   id: 'constant',
  //   name: 'Constant',
  //   description: "As simple as a constant value. It doesn't take any inputs and it is always the same.",
  //   type: 'standard',
  //   outputType: ['string', 'number', 'boolean'],
  //   inputs: false,
  //   onlyOneInput: false,
  //   group: 'no-inputs'
  // },
  {
    id: 'makeId',
    name: 'Create random ID',
    description: "Creates a random id using letters (case sensitive) and numbers",
    type: 'standard',
    outputType: ['string'],
    inputs: false,
    onlyOneInput: false,
    group: 'no-inputs',
    auxParamsNumber: true,
    hasExample: true
  },
  {
    id: 'joinInputs',
    name: 'Join inputs',
    description: "Concatenate all inputs using a separator. Result is always a string.",
    type: 'standard',
    outputType: ['string'],
    inputs: true,
    onlyOneInput: false,
    group: 'arrays',
    auxParamsString: true,
    hasExample: true
  },
  {
    id: 'mostFrequent',
    name: 'Most frequent',
    description: "Get the value found more times within the inputs. If all inputs are unique, it will return the first one.",
    type: 'advanced',
    outputType: ['any'],
    inputs: true,
    onlyOneInput: false,
    group: 'occurrences',
    hasExample: true
  },
  {
    id: 'leastFrequent',
    name: 'Least frequent',
    description: "Get the value found less times within the inputs. If all inputs are unique, it will return the first one.",
    type: 'advanced',
    outputType: ['any'],
    inputs: true,
    onlyOneInput: false,
    group: 'occurrences',
    hasExample: true
  },
  {
    id: 'join',
    name: 'Join',
    description: "Takes the input (array expected) and joins it using the separator.",
    type: 'advanced',
    outputType: ['string'],
    inputs: true,
    onlyOneInput: true,
    group: 'arrays',
    auxParamsString: true,
    hasExample: true
  },
  {
    id: 'split',
    name: 'Split',
    description: "Split the input and gets the n-th element. It only accepts one input and it must be a string.",
    type: 'advanced',
    outputType: ['string'],
    inputs: true,
    onlyOneInput: true,
    group: 'arrays',
    auxParamsString: true,
    auxParamsNumber: true,
    hasExample: true
  },
  {
    id: 'stringify',
    name: 'Stringify',
    description: "Converts the input into a string. It only accepts one input.",
    type: 'standard',
    outputType: ['string'],
    inputs: true,
    onlyOneInput: true,
    group: 'strings',
    hasExample: true
  },
  {
    id: 'itemInList',
    name: 'Item in list',
    description: "Get one object from a list of objects using a key-value pair to identify it",
    type: 'advanced',
    outputType: ['any'],
    inputs: true,
    onlyOneInput: true,
    group: 'arrays',
    auxParamsString0: true,
    auxParamsString: true,
    hasExample: true
  },
  {
    id: 'nthArrayItem',
    name: 'nth list item',
    description: "Gets the nth list item from the value",
    type: 'standard',
    outputType: ['any'],
    inputs: true,
    onlyOneInput: true,
    group: 'arrays',
    auxParamsNumber: true,
    hasExample: true
  },
  {
    id: 'extractUrlParam',
    name: 'Extract URL parameter',
    description: "URLs can contain several parameters. This function extracts the value of the parameter you need.",
    type: 'advanced',
    outputType: ['string'],
    inputs: true,
    onlyOneInput: false,
    group: 'urls',
    auxParamsString: true,
    hasExample: true
  },
  {
    id: 'encodeURI',
    name: 'Encode URL',
    description: "Encodes URL using the JavaScript function encodeURI(text)",
    type: 'standard',
    outputType: ['string'],
    inputs: true,
    onlyOneInput: false,
    group: 'urls',
    hasExample: true
  },
  {
    id: 'decodeURI',
    name: 'Decode URL',
    description: "Decodes URL using the JavaScript function decodeUri(text)",
    type: 'standard',
    outputType: ['string'],
    inputs: true,
    onlyOneInput: false,
    group: 'urls',
    hasExample: true
  },
  {
    id: 'extractEmailDomain',
    name: 'Extract domain from an email',
    description: "Gets the email domain. Just be sure you are passing an email as an input.",
    type: 'advanced',
    outputType: ['string'],
    inputs: true,
    onlyOneInput: true,
    group: 'emails',
    hasExample: true
  },
  {
    id: 'extractEmailName',
    name: 'Extract name from an email',
    description: "Gets the email name. Just be sure you are passing an email as an input.",
    type: 'advanced',
    outputType: ['string'],
    inputs: true,
    onlyOneInput: true,
    group: 'emails',
    hasExample: true
  },
  {
    id: 'getDomainName',
    name: 'Get domain name',
    description: "Extracts domain name from a given URL.",
    type: 'advanced',
    outputType: ['string'],
    inputs: true,
    onlyOneInput: true,
    group: 'urls',
    hasExample: true
  },
  {
    id: 'getTopLevelDomain',
    name: 'Get top level domain (domain extension)',
    description: "Extracts top level domain (extension) from a given URL.",
    type: 'advanced',
    outputType: ['string'],
    inputs: true,
    onlyOneInput: true,
    group: 'urls',
    hasExample: true
  },
  {
    id: 'getSecondLevelDomain',
    name: 'Get second level domain',
    description: "Extracts second level domain (domain name without extension) from a given URL.",
    type: 'advanced',
    outputType: ['string'],
    inputs: true,
    onlyOneInput: true,
    group: 'urls',
    hasExample: true
  },
  {
    id: 'getHostName',
    name: 'Get host name',
    description: "Extracts host name from a given URL.",
    type: 'advanced',
    outputType: ['string'],
    inputs: true,
    onlyOneInput: true,
    group: 'urls',
    hasExample: true
  },
  {
    id: 'getLinkedinHandle',
    name: 'Extract LinkedIn handle',
    description: "Given a LinkedIn url for a person or company, extracts the handle",
    type: 'advanced',
    outputType: ['string'],
    inputs: true,
    onlyOneInput: true,
    group: 'urls',
    hasExample: true
  },
  {
    id: 'isValidEmail',
    name: 'Is email valid?',
    description: "Returns true if the input is formatted as a valid email, false otherwise",
    type: 'standard',
    outputType: ['boolean'],
    inputs: true,
    onlyOneInput: true,
    group: 'emails',
    hasExample: true
  },
  {
    id: 'isValidDomain',
    name: 'Is domain valid?',
    description: "Returns true if the input is formatted as a valid domain, false otherwise.",
    type: 'standard',
    outputType: ['string'],
    inputs: true,
    onlyOneInput: true,
    group: 'urls',
    hasExample: true
  },
  {
    id: 'toLower',
    name: 'to lowercase',
    description: "Converts a string to lowercase.",
    type: 'standard',
    outputType: ['string'],
    inputs: true,
    onlyOneInput: true,
    group: 'strings',
    hasExample: true
  },
  {
    id: 'toUpper',
    name: 'To UPPER case',
    description: "Converts a string to uppercase.",
    type: 'standard',
    outputType: ['string'],
    inputs: true,
    onlyOneInput: true,
    group: 'strings',
    hasExample: true
  },
  {
    id: 'toTitle',
    name: 'To Title Case',
    description: "Converts a string to title case (each letter of the word capitalized).",
    type: 'standard',
    outputType: ['string'],
    inputs: true,
    onlyOneInput: true,
    group: 'strings',
    hasExample: true
  },
  {
    id: 'toSnake',
    name: 'To snake_case',
    description: "Converts a string to snake case (this_is_snake_case).",
    type: 'standard',
    outputType: ['string'],
    inputs: true,
    onlyOneInput: true,
    group: 'strings',
    hasExample: true
  },
  {
    id: 'toKebab',
    name: 'To kebab-case',
    description: "Converts a string to kebab case (this-is-kebab-case).",
    type: 'standard',
    outputType: ['string'],
    inputs: true,
    onlyOneInput: true,
    group: 'strings',
    hasExample: true
  },
  {
    id: 'toCamel',
    name: 'To camelCase',
    description: "Converts a string to camel case (thisIsCamelCase).",
    type: 'standard',
    outputType: ['string'],
    inputs: true,
    onlyOneInput: true,
    group: 'strings',
    hasExample: true
  },
  {
    id: 'wrapString',
    name: 'Wrap string',
    description: "Wrap a string with additional characters on both ends.",
    type: 'standard',
    outputType: ['string'],
    inputs: true,
    onlyOneInput: true,
    group: 'strings',
    auxParamsString: true,
    auxParamsString0: true,
    hasExample: true
  },
  {
    id: 'findFirstOccurrence',
    name: 'Find first occurrence in list',
    description: "Given a list of strings, find the first occurrence in an input array. In other words, it gets the first white-listed element from a list.",
    type: 'advanced',
    outputType: ['string'],
    inputs: true,
    onlyOneInput: true,
    group: 'arrays',
    hasExample: true
  },
  {
    id: 'executionId',
    name: 'Execution ID',
    description: "Gets the DataMorf workflow execution id. This is usually a 25 characters long string.",
    type: 'standard',
    outputType: ['string'],
    inputs: false,
    onlyOneInput: false,
    group: 'no-inputs',
    hasExample: true
  },
  {
    id: 'stopExecution',
    name: 'Stop execution',
    description: "Stops the execution of the workflow. Nothing beyond this point will get processed.",
    type: 'standard',
    outputType: [],
    inputs: false,
    onlyOneInput: false,
    group: 'no-inputs',
    hasExample: true
  },
  {
    id: 'searchString',
    name: 'Search string',
    description: "Searches for a specific value in a string. It accepts regular expressions.",
    type: 'advanced',
    outputType: ['string'],
    inputs: true,
    onlyOneInput: true,
    group: 'strings',
  },
  {
    id: 'replaceString',
    name: 'Replace string',
    description: "Replaces a specific value for another in a string. It accepts regular expressions.",
    type: 'advanced',
    outputType: ['string'],
    inputs: true,
    onlyOneInput: true,
    group: 'strings',
  },
  {
    id: 'cleanHtml',
    name: 'Clean Html tags',
    description: "Get the plain text contained in an html content",
    type: 'advanced',
    outputType: ['string'],
    inputs: true,
    onlyOneInput: true,
    group: 'strings',
  },
  {
    id: 'sortList',
    name: 'Sort list',
    description: "Sort a list of elements and get a specific item or the full list",
    type: 'advanced',
    outputType: ['any'],
    inputs: true,
    onlyOneInput: true,
    group: 'arrays',
    hasExample: true
  },
  {
    id: 'path',
    name: 'Dot notation path',
    description: "Tries to access a dot notation path on a given value",
    type: 'standard',
    outputType: ['any'],
    inputs: true,
    onlyOneInput: true,
    group: 'basic',
    hasExample: true
  },
  {
    id: 'makeArrayWithInputs',
    name: 'Make list with inputs',
    description: "Creates an array with each input as an item.",
    type: 'standard',
    outputType: ['any'],
    inputs: true,
    onlyOneInput: false,
    group: 'arrays',
    hasExample: true
  },
  {
    id: 'extractPropertyFromArrayOfObjects',
    name: 'Extract property from array of objects',
    description: "Extracts a given property for each element of a list",
    type: 'advanced',
    outputType: ['any'],
    inputs: true,
    onlyOneInput: true,
    group: 'arrays',
    hasExample: true
  },
  {
    id: 'getSize',
    name: 'Get size',
    description: "Get how many items are in a list or object. It also counts characters of a string.",
    type: 'standard',
    outputType: ['number'],
    inputs: true,
    onlyOneInput: true,
    group: 'occurrences',
    hasExample: true
  },
  {
    id: 'getDate',
    name: 'Get date',
    description: "Get a date formatted string out of a given input. If not input is provided it will default to current date time",
    type: 'standard',
    outputType: ['string'],
    inputs: true,
    onlyOneInput: true,
    group: 'dateAndTime',
  },
  {
    id: 'addDate',
    name: 'Add date',
    description: "Add a specific amount of hours, days, week, etc, to a given date.",
    type: 'standard',
    outputType: ['string'],
    inputs: true,
    onlyOneInput: true,
    group: 'dateAndTime',
  },
  {
    id: 'formatDate',
    name: 'Format date',
    description: "Applies a specific format to a date object so it can be read as a string",
    type: 'standard',
    outputType: ['string'],
    inputs: true,
    onlyOneInput: true,
    group: 'dateAndTime',
  },
  {
    id: 'freeText',
    name: 'Free text',
    description: "Write a free text with your own transformations in it.",
    type: 'standard',
    outputType: ['string'],
    inputs: false,
    onlyOneInput: false,
    group: 'strings'
  },
  {
    id: 'richText',
    name: 'Rich text',
    description: "Write a rich text with your own transformations in it.",
    type: 'advanced',
    outputType: ['string'],
    inputs: false,
    onlyOneInput: false,
    group: 'strings'
  },
  {
    id: 'gptPrompt',
    name: 'GPT Prompt (old)',
    description: "Create a custom prompt with your own variables and send it to GPT to get an AI generated response. This transformation uses the old OpenAI prompt API, please consider using the new one instead.",
    type: 'advanced',
    outputType: ['any'],
    inputs: false,
    onlyOneInput: false,
    group: 'ai',
    icon: 'openAI',
    hasExample: true
  },
  {
    id: 'gptResponse',
    name: 'GPT Prompt',
    description: "Create a custom prompt with your own variables and send it to GPT models to get an AI generated response. This transformation uses the new OpenAI responses API",
    type: 'advanced',
    outputType: ['any'],
    inputs: false,
    onlyOneInput: false,
    group: 'ai',
    icon: 'openAI',
    hasExample: true
  },
  {
    id: 'claudeAIPrompt',
    name: 'Claude AI Prompt',
    description: "Create a custom prompt with your own variables and send it to Claude to get an AI generated response.",
    type: 'advanced',
    outputType: ['any'],
    inputs: false,
    onlyOneInput: false,
    group: 'ai',
    icon: 'claudeAI',
  },
  {
    id: 'promptLayer',
    name: 'Prompt Layer',
    description: "Run a PromptLayer template to get an AI generated response.",
    type: 'advanced',
    outputType: ['any'],
    inputs: true,
    onlyOneInput: false,
    group: 'ai',
    icon: 'promptLayer',
  },
  {
    id: 'normalizer',
    name: 'Name normalizer',
    description: "Normalize company names, person names and job titles with the power of AI",
    type: 'advanced',
    outputType: ['string'],
    inputs: true,
    onlyOneInput: true,
    group: 'ai',
    hasExample: true
  },
  {
    id: 'regexMatch',
    name: 'Regex match',
    description: "Match a string with a regular expression",
    type: 'advanced',
    outputType: ['string'],
    inputs: true,
    onlyOneInput: true,
    group: 'strings',
  },
  {
    id: 'jsonParse',
    name: 'JSON parse',
    description: "Parse a JSON string into a JSON object",
    type: 'standard',
    outputType: ['string'],
    inputs: true,
    onlyOneInput: true,
    group: 'strings',
  },
  {
    id: 'dictionary',
    name: 'Dictionary (switch - case)',
    description: "Also known as switch-case. Get a specific result given a specific value. Compare input value with a key, and get its value as a result.",
    type: 'advanced',
    outputType: ['any'],
    inputs: true,
    onlyOneInput: false,
    group: 'other',
    hasExample: true
  },
  {
    id: 'custom',
    name: 'Custom code',
    description: "Write your own JS code. Useful to tailor every detail from your data point.",
    type: 'standard',
    outputType: ['any'],
    inputs: false,
    onlyOneInput: false,
    group: 'other'
  },
  {
    id: 'customComputation',
    name: 'Custom transformation',
    description: "Run your own pre-defined custom transformation.",
    type: 'advanced',
    outputType: ['any'],
    inputs: true,
    onlyOneInput: false,
    group: 'other'
  },
  {
    id: 'randomSelection',
    name: 'Random selection',
    description: "Randomly select one element from all transformation inputs. All values have the same chance of getting selected.",
    type: 'advanced',
    outputType: ['any'],
    inputs: true,
    onlyOneInput: false,
    group: 'arrays',
    hasExample: true
  },
  {
    id: 'perplexityCompletion',
    name: 'Perplexity Completion',
    description: "Create a custom prompt with your own variables and send it to Perplexity models to get an AI generated response.",
    type: 'advanced',
    outputType: ['any'],
    inputs: false,
    onlyOneInput: false,
    group: 'ai',
    icon: 'perplexity',
    hasExample: false
  },
  {
    id: 'perplexitySearch',
    name: 'Perplexity Search',
    description: "Get ranked search results from Perplexity models based on a given query.",
    type: 'advanced',
    outputType: ['any'],
    inputs: false,
    onlyOneInput: false,
    group: 'ai',
    icon: 'perplexity',
    hasExample: false
  },
  {
    id: 'mistralOcr',
    name: 'Mistral OCR',
    description: "Extract document or image data using the best OCR model by Mistral.",
    type: 'advanced',
    outputType: ['any'],
    inputs: false,
    onlyOneInput: false,
    group: 'ai',
    icon: 'mistral',
    hasExample: false
  },
  {
    id: 'cropPdf',
    name: 'Crop PDF',
    description: "Extract a selection of pages from a PDF file and get a new file with only those pages.",
    type: 'advanced',
    outputType: ['any'],
    inputs: false,
    onlyOneInput: false,
    group: 'files',
    hasExample: false
  },
]

export const customCodeLibraries: {name: string, alias: string, selected: boolean}[] = [
  { name: 'Lodash', alias: '_', selected: true },
  { name: 'cheerio', alias: 'cheerio', selected: false },
  { name: 'axios', alias: 'axios', selected: false },
  { name: 'dateFns', alias: 'dateFns', selected: false },
  { name: 'mathjs', alias: 'mathjs', selected: false },
  { name: 'validator', alias: 'validator', selected: false },
  { name: 'xml2js', alias: 'xml2js', selected: false },
  { name: 'papaparse', alias: 'Papa', selected: false },
  { name: 'cryptoJs', alias: 'cryptoJs', selected: false },
]
